<template>
  <transition name="fade">
    <div v-if="!atTopOfPage">
      <v-btn
        id="scrollToTopButton"
        :fixed="!atBottomOfPage"
        :absolute="atBottomOfPage"
        fab
        dark
        bottom
        right
        color="#d1d3d4"
        @click="$vuetify.goTo(0, scrollOptions)"
        :style="{ marginBottom: atBottomOfPage ? '-50px' : '0px' }"
        aria-label="Scroll to top"
      >
        <v-icon color="#1b365d">mdi-arrow-up-bold-outline</v-icon>
      </v-btn>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ScrollToTopButton",

  data() {
    return {
      atTopOfPage: true,
      atBottomOfPage: false
    };
  },
  methods: {
    scroll() {
      window.onscroll = () => {
        this.checkWindowPosition();
      };
    },
    checkWindowPosition() {
      const topOfWindow =
        Math.max(
          window.pageYOffset,
          document.documentElement.scrollTop,
          document.body.scrollTop
        ) < 500;
      const bottomOfWindow =
        Math.max(
          window.pageYOffset,
          document.documentElement.scrollTop,
          document.body.scrollTop
        ) +
          window.innerHeight >=
        document.documentElement.offsetHeight;

      if (topOfWindow) {
        this.atTopOfPage = true;
      } else {
        this.atTopOfPage = false;
      }

      if (bottomOfWindow) {
        this.atBottomOfPage = true;
      } else {
        this.atBottomOfPage = false;
      }
    }
  },
  computed: {
    scrollOptions() {
      return {
        duration: 250,
        easing: "linear"
      };
    }
  },
  mounted() {
    this.scroll();
    this.checkWindowPosition();
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
